import React from 'react';
import { Props } from './renderContent';
import TextBox from '../TextBox/TextBox';

const Strong = ({ children, options }: Props) => React.createElement(TextBox, { children, options, bold: true });

export default Strong;